<template>
  <div class="container">
    <h1>全局模态弹窗测试</h1>
    <div class="button-group">
      <button @click="showInfoModal">显示信息弹窗</button>
      <button @click="showSuccessModal">显示成功弹窗</button>
      <button @click="showErrorModal">显示错误弹窗</button>
      <button @click="showWarningModal">显示警告弹窗</button>
      <button @click="showConfirmModal">显示确认弹窗</button>
      <button @click="showToastMessage">显示Toast消息</button>
      <button @click="showCustomModal">显示自定义弹窗</button>
    </div>
  </div>
</template>

<script>
import ModalService from '@/ui_server/modalService';

export default {
  name: 'TestModalView',
  methods: {
    showInfoModal() {
      ModalService.showInfo('信息', '这是一个信息弹窗');
    },
    
    showSuccessModal() {
      ModalService.showSuccess('成功', '操作成功完成');
    },
    
    showErrorModal() {
      ModalService.showError('错误', '操作失败，请重试');
    },
    
    showWarningModal() {
      ModalService.showWarning('警告', '这是一个警告消息');
    },
    
    showConfirmModal() {
      ModalService.showConfirm(
        '确认', 
        '您确定要执行此操作吗？', 
        () => {
          ModalService.showToast('操作已确认');
        },
        () => {
          ModalService.showToast('操作已取消');
        }
      );
    },
    
    showToastMessage() {
      ModalService.showToast('这是一条Toast消息');
    },
    
    showCustomModal() {
      ModalService.showCustom({
        title: '自定义弹窗',
        message: '这是一个自定义弹窗，您可以设置各种选项',
        type: 'modal',
        showHeader: true,
        showFooter: true,
        confirmText: '确定',
        modal: false, // 非模态弹窗
        duration: 5000
      });
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  text-align: center;
}

.button-group {
  margin-top: 20px;
}

.button-group button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.button-group button:hover {
  background-color: #3367d6;
}
</style>
